module.exports = __webpack_public_path__ + "70bd70a9fcd9e7a894d7d37f4105d3c5.png";